/**
 * convert width and fwhm to ppm
 */
export function convertWidth(peaks, options) {
    const { frequency, convertTo, output = JSON.parse(JSON.stringify(peaks)), } = options;
    const convert = getConverter(convertTo, frequency);
    for (const peak of output) {
        peak.width = convert(peak.width);
        if (hasShape(peak)) {
            if (peak.shape.fwhm) {
                peak.shape.fwhm = convert(peak.shape.fwhm);
            }
        }
    }
    return output;
}
function hasShape(peak) {
    return 'shape' in peak;
}
function getConverter(convertTo, frequency) {
    switch (convertTo) {
        case 'ppm':
            return (x) => x / frequency;
        case 'hz':
            return (x) => x * frequency;
        default:
            throw new Error(`Does not support convert to ${convertTo}`);
    }
}
//# sourceMappingURL=convertWidth.js.map